import * as React from 'react';
import { getUserApi, resetPassRqApi, logInApi } from '../api/api';
import { Link, useNavigate } from 'react-router-dom';
import BtnFilled from '../components/BtnFilled';
import Input from '../components/Input';
import InputPasswd from '../components/InputPasswd';
import Modal from '../components/Modal';
import AlertAccent from '../components/AlertAccent';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useUserStore } from '../stores';

// Iris&3621#

const Login = () => {
  const { setUser, setAuthorized } = useUserStore();

  const [showAddModal, setShowAddModal] = React.useState(false);

  const [refreshing, setRefreshing] = React.useState(false);

  const testLogIn =
    process.env.REACT_APP_MODE === 'dev'
      ? {
          username: 'rise33@yandex.ru',
          password: '$outh3*3Cross',
        }
      : {};

  const navigate = useNavigate();
  //username: 'flassie6',
  //password: '123',
  // Iris&3621#
  const [_user, _setUser] = React.useState(testLogIn);
  const [_error, _setError] = React.useState({});

  const login = async () => {
    setRefreshing(true);
    await logInApi(
      _user,
      async function (data) {},
      function (err) {
        setRefreshing(false);
        toast.error(err.error ? err.error : 'Ошибка сервера 1', { hideProgressBar: false });
      }
    );

    await getUserApi(
      function (data) {
        setUser(data);
        setAuthorized(true);
      },
      function (err) {
        setAuthorized(false);
      }
    );
  };

  const [resPass, setResPass] = React.useState({ redirect_link: process.env.REACT_APP_REDIRECT_LINK + 'resetpass', email: _user.username });
  const [resErr, setResErr] = React.useState([]);
  const [resOk, setResOk] = React.useState(false);

  const reset = async () => {
    setResErr([]);
    await resetPassRqApi(
      resPass,
      function (data) {
        setResOk(true);
      },
      function (err) {
        toast.error(err.error ? err.error : 'Ошибка сервера', { hideProgressBar: false });
        setResErr((p) => [...p, err.error ? err : { error: 'Ошибка сервера' }]);
      }
    );
  };

  const close = async () => {
    setResErr([]);
    toast.dismiss();
  };

  return (
    <div className="w-full max-w-lg">
      <form className="bg-white shadow-2xl rounded-b-3xl border-b border-x border-gray-300 px-8 pt-6 pb-8 mb-4">
        <Input
          classContainer={'mb-4'}
          label="Ваш email"
          value={_user.username}
          inputCb={(e) => _setUser({ ..._user, username: e.target.value.toLowerCase() })}
          id="username"
          type="text"
          autoComplete="username"
          placeholder="someone@example.com"
          maxLength={255}
        />
        <InputPasswd
          classContainer={'mb-4'}
          label="Пароль"
          value={_user.password}
          inputCb={(e) => _setUser({ ..._user, password: e.target.value })}
          id="password"
          autoComplete="current-password"
        />

        {_error && <p className="mb-4 text-red-500 p-0 font-bold text-xs italic">{_error.error}</p>}
        <div className="mb-4">
          <BtnFilled
            title={
              refreshing ? (
                <div
                  className="inline-block h-5 w-5 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                  role="status"
                />
              ) : (
                'Войти'
              )
            }
            btnCb={login}
          />
        </div>

        <BtnFilled title="Сбросить пароль" btnCb={() => setShowAddModal(true)}></BtnFilled>
        <Link to={'/instruction'} className={'underline text-orange-400 mt-1.5 block hover:text-orange-500 text-sm'}>
          Инструкции для пользователя
        </Link>
      </form>
      <Modal
        showModal={showAddModal}
        setShowModal={setShowAddModal}
        titleOn="Сбросить"
        saveCb={() => reset()}
        showSave={!resOk}
        closeCb={() => close()}
        title="Сброс пароля"
        error={resErr}>
        <Input
          classContainer={'mb-4'}
          label="Для сброса пароля введите ваш email"
          value={resPass.email}
          inputCb={(e) => setResPass({ ...resPass, email: e.target.value })}
          id="login"
          type="text"
          placeholder={'someone@example.com'}></Input>
        {resOk && <AlertAccent title="" text="На вашу почту была отправлена ссылка. Для сброса пароля перейдите по ней" showAlert={true}></AlertAccent>}
      </Modal>
    </div>
  );
};

export default Login;
